import { PhxTableCellTagPlacement, PhxTableCellTextStyle } from '../phx-table.types';
import { PhxTagSize } from '../../tag/phx-tag.types';
import { PHX_SIZE } from '../../../constants';

export const DEFAULT_PRIMARY_CONFIG: PhxTableCellTextStyle = {
  intent: 'standard',
  emphasis: false,
  italic: false,
  truncate: false,
};

/** Default style knobs for secondary/tertiary segments. Shared by phx-table-cell-string and phx-table-cell-tag. */
export const DEFAULT_SECONDARY_AND_TERTIARY_CONFIG: PhxTableCellTextStyle = {
  intent: 'subdued',
  emphasis: false,
  italic: false,
  truncate: false,
};

export const PHX_TABLE_CELL_TAG_PLACEMENT = {
  TAG_ONLY: 'tag-only',
  AS_PRIMARY: 'as-primary',
  ABOVE_PRIMARY: 'above-primary',
  BELOW_PRIMARY: 'below-primary',
  RIGHT_OF_PRIMARY: 'right-of-primary',
  RIGHT_OF_SECONDARY: 'right-of-secondary',
} as const;

export const PHX_SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
} as const;

export const PHX_TABLE_CELL_MEDIA_TYPE = {
  IMAGE: 'image',
  VIDEO: 'video',
} as const;

export const PHX_TABLE_CELL_MEDIA_SIZE = {
  DEFAULT: 'default',
  LARGE: 'large',
} as const;

/**
 * Inner `phx-tag` size per placement. Shared by phx-table-cell-tag (drives its own
 * `<phx-tag>` directly) and phx-table-cell-custom (exposes this via `resolvedTagSize`
 * for consumers to bind explicitly on their projected `<phx-tag>`), so a given
 * placement always resolves to the same tag size regardless of which cell renders it.
 */
export const TAG_SIZE_BY_PLACEMENT: Record<PhxTableCellTagPlacement, PhxTagSize> = {
  [PHX_TABLE_CELL_TAG_PLACEMENT.TAG_ONLY]: PHX_SIZE.MD,
  [PHX_TABLE_CELL_TAG_PLACEMENT.AS_PRIMARY]: PHX_SIZE.SM,
  [PHX_TABLE_CELL_TAG_PLACEMENT.ABOVE_PRIMARY]: PHX_SIZE.XS,
  [PHX_TABLE_CELL_TAG_PLACEMENT.BELOW_PRIMARY]: PHX_SIZE.XS,
  [PHX_TABLE_CELL_TAG_PLACEMENT.RIGHT_OF_PRIMARY]: PHX_SIZE.SM,
  [PHX_TABLE_CELL_TAG_PLACEMENT.RIGHT_OF_SECONDARY]: PHX_SIZE.XS,
};
